<ng-container *ngIf="pdfDetails">
    <ng-container *ngIf="pageIncluded(PDFPageKeys.RISKS_OPPORTUNITIES)">
        <app-pdf-page-risks-and-opportunities [pdfDetails]="pdfDetails" [options]="pageOptions(PDFPageKeys.RISKS_OPPORTUNITIES)" [clientOnly]="false"></app-pdf-page-risks-and-opportunities>
    </ng-container>
    <ng-container *ngIf="pageIncluded(PDFPageKeys.RISKS_OPPORTUNITIES_CLIENT)">
        <app-pdf-pagebreak *ngIf="needPageBreak(PDFPageKeys.RISKS_OPPORTUNITIES_CLIENT)"></app-pdf-pagebreak>
        <app-pdf-page-risks-and-opportunities [pdfDetails]="pdfDetails" [options]="pageOptions(PDFPageKeys.RISKS_OPPORTUNITIES_CLIENT)" [clientOnly]="true"></app-pdf-page-risks-and-opportunities>
    </ng-container>
</ng-container>
